/* eslint-disable react/prop-types */
import React, { useState } from "react";

import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

import { blue } from "@mui/material/colors";
import DistributionFormModal from "../../../components/DistributionFormModal/DistributionFormModal";

const Forms = ({ formDocuments = [], track }) => {
  // console.log(formDocuments);
  const safeFormDocuments = formDocuments || [];

  const [distributionModal, setDistributionModal] = useState({
    open: false,
    planType: '',
    docURL: ''
  });

  const handleFormClick = (e, doc) => {
    e.preventDefault();

    if (track) {
      track({
        event_type: "download",
        item_type: "document",
        item_id: doc.documentId,
        item_name: doc.documentName,
        item_section: doc.displaySection || doc.docType?.split(" - ")[1],
        plan_type: doc.planType || doc.docType?.split(" - ")[0],
      });
    }

    // Modal disabled - admin distribution forms now download directly
    // if (doc.documentName?.toLowerCase().includes('admin distribution')) {
    //   // Show modal for distribution forms
    //   setDistributionModal({
    //     open: true,
    //     planType: doc.planType,
    //     docURL: doc.docURL
    //   });
    //   return;
    // }

    // For all forms, proceed with immediate download
    // Check if we're in an iframe environment
    if (window.triggerExternalVendorLink && window.parent !== window) {
      // In iframe: use the external navigation system
      window.triggerExternalVendorLink(doc.docURL);
    } else {
      // Standalone or fallback: create a temporary anchor and click it
      // This approach is more reliable with popup blockers
      const link = document.createElement('a');
      link.href = doc.docURL;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleDistributionCancel = () => {
    setDistributionModal({ open: false, planType: '', docURL: '' });
  };

  const handleDistributionConfirm = () => {
    const docURL = distributionModal.docURL;

    // Same download logic as non-distribution forms
    if (window.triggerExternalVendorLink && window.parent !== window) {
      window.triggerExternalVendorLink(docURL);
    } else {
      const link = document.createElement('a');
      link.href = docURL;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    // Close modal
    setDistributionModal({ open: false, planType: '', docURL: '' });
  };
  
  return (
    <>
      {safeFormDocuments.length > 0 && (
        <Typography
          variant="h6"
          sx={{
            margin: "8px 0",
            padding: "0 8px",
            alignItems: "center",
            backgroundColor: blue[700],
            color: "white",
          }}
        >
          Forms
        </Typography>
      )}
      {safeFormDocuments.map((doc) => (
        <ListItem
          key={doc.documentId}
          button
          onClick={(e) => handleFormClick(e, doc)}
          sx={{ cursor: 'pointer' }}
        >
          <ListItemText primary={doc.documentName} sx={{ color: blue[700] }} />
        </ListItem>
      ))}
      <DistributionFormModal
        open={distributionModal.open}
        planType={distributionModal.planType}
        onCancel={handleDistributionCancel}
        onConfirm={handleDistributionConfirm}
      />
    </>
  );
};


export default Forms;
